<script lang="ts">
  import emblaCarouselSvelte from "embla-carousel-svelte";
  import type { EmblaCarouselType } from "embla-carousel";

  let numberOfSlides = 1;
  let index = 0;
  export let emblaApi: EmblaCarouselType;
  const carouselOptions = { loop: false };

  const onCarouselInit = (event: CustomEvent<EmblaCarouselType>) => {
    emblaApi = event.detail;
    numberOfSlides = emblaApi.slideNodes().length;

    emblaApi.on("select", () => {
      index = emblaApi.selectedScrollSnap();
    });
  };

  const gotoIndex = (i: number) => {
    emblaApi.scrollTo(i);
  };
</script>

<div class="embla" use:emblaCarouselSvelte={{ options: carouselOptions, plugins: [] }} on:emblaInit={onCarouselInit}>
  <div class="embla__container">
    <slot />
  </div>
  <div class="flex w-full justify-center mt-6">
    <div class="flex gap-2">
      {#each Array.from(Array(numberOfSlides).keys()) as i}
        <button on:click={() => gotoIndex(i)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
            <circle class="dot" class:active={i === index} cx="4" cy="4" r="4" stroke="none" />
          </svg>
        </button>
      {/each}
    </div>
  </div>
</div>

<style>
  .embla {
    margin: auto;
    --slide-height: 20rem;
    --slide-spacing: 1rem;
    --slide-size: 70%;
    overflow: hidden;
  }

  .embla__container {
    backface-visibility: hidden;
    display: flex;
    touch-action: pan-y pinch-zoom;
    margin-left: calc(var(--slide-spacing) * -1);
  }

  .dot {
    opacity: 0.3;
    fill: var(--color-purple-50);
  }

  .dot.active {
    opacity: 1;
  }
</style>
